const dashboardRoutes = {
  path: 'dashboards',
  name: 'dashboardssOverview',
  components: {
    default: () => import('@/views/PageRoutView')
  },
  redirect: { name: 'dashboards' },
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: '/:channelId/dashboards/search',
      name: 'dashboards-dashboards',
      component: () => import('@/views/Dashboards/Search'),
      meta: {
        requiresAuth: true
      }
    },
  ]
}

export default dashboardRoutes
